import { Box } from '@customink/pigment-react';

import './Spinner.css';

const childStyles = (size: number, color: string) => ({
  boxSizing: 'border-box',
  display: 'block',
  position: 'absolute',
  width: `${size * 0.8}px`,
  height: `${size * 0.8}px`,
  margin: `${size * 0.1}px`,
  border: `${size * 0.1}px solid ${color}`,
  borderRadius: '50%',
  animation: 'lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
  borderColor: `${color} transparent transparent transparent`,
});

export default function Spinner({ size = 80, color = '#fff' }) {
  return (
    <Box
      className="lds-ring"
      data-testid="spinner"
      sx={{
        display: 'inlineBlock',
        position: 'relative',
        width: size,
        height: size,
      }}
    >
      <Box sx={childStyles(size, color)} />
      <Box sx={{ ...childStyles(size, color), animationDelay: '-0.45s' }} />
      <Box sx={{ ...childStyles(size, color), animationDelay: '-0.3s' }} />
      <Box sx={{ ...childStyles(size, color), animationDelay: '-0.15s' }} />
    </Box>
  );
}
